import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ControlCenter } from './control-center'
import { ControlCenterService } from './control-center.service'

@Injectable({
  providedIn: 'root',
})
export class ControlCenterResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private controlCenterService = inject(ControlCenterService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<ControlCenter> {
    const id = route.paramMap.get('id')
    return this.controlCenterService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
